module.exports = __webpack_public_path__ + "static/media/29_B.d350ce1f.png";